<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Cartões de Milhagem" exibeVoltar="true" historyback="true"/>
        </div>
		<div class="app-centro-sem-rodape">
            <div v-if="!milhagens.length" class="msg-error">
                <center>
                    <i v-if="mensagem" class="fas fa-exclamation-triangle"></i> {{mensagem}}
                </center>
            </div>
            <table style="width: 100%; top-margin: 20px;">
                <tbody  v-for="milhagem in milhagens" v-bind:key="milhagem.UID">
                    <tr>
                        <td><b>Cia:</b></td>
                        <td>{{milhagem.CIA}}</td>
                    </tr>
                    <tr>
                        <td><b>Cartão:</b></td>
                        <td>{{milhagem.NUM_CARTAO}}</td>
                    </tr>
                    <tr>
                        <td><b>Obs:</b></td>
                        <td>{{milhagem.OBS}}</td>
                    </tr>
                    <tr>
                        <td colspan="2"><hr/></td>
                    </tr>
                </tbody>
            </table>      
        </div>
	</div>

</template>

<script>


import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';


export default {
    name: 'MilhagemCliente',
    props: ['id'],
    components: {
        TopBar
    },
    data() {
        return {
            mensagem : '',
            milhagens : {}
        };        
    },
    mounted: function () {
        var codcliente = JSON.parse(atob(this.id));

        request(this, 'GET',
            'Mobile_GetMilhagemCliente',
            `cod_cliente=${codcliente}`)
        .then(res => {
            if(res){
                this.milhagens = res.milhagem;
                if(!this.milhagens.length)
                this.mensagem = 'Nenhum cartão de milhagem cadastrado!';
            }
        });

    }
    
}


</script>